import D1 from "../assets/1.png"
import D2 from "../assets/2.png"
import D3 from "../assets/3.png"
import D4 from "../assets/4.png"
import D5 from "../assets/5.png"
import D6 from "../assets/6.png"
import D7 from "../assets/7.png"
import D8 from "../assets/8.png"
import D9 from "../assets/9.png"
import D0 from "../assets/0.png"

const dayReducer = (state = null, action) => {
    switch(action.type){
        case "setDay1":
            return D1
        case "setDay2":
            return D2
        case "setDay3":
            return D3
        case "setDay4":
            return D4
        case "setDay5":
            return D5
        case "setDay6":
            return D6
        case "setDay7":
            return D7
        case "setDay8":
            return D8
        case "setDay9":
            return D9
        case "setDay0":
            return D0
        default:
            return state
    }
}

export default dayReducer